import { useNavigate } from "react-router-dom";
import { XCircle, ArrowLeft, HelpCircle, Zap } from "lucide-react";

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F8FAFC] font-['Outfit'] flex items-center justify-center px-4">
      <div className="w-full max-w-md text-center">

        {/* Icon */}
        <div className="w-20 h-20 bg-orange-50 rounded-full flex items-center justify-center mx-auto mb-6 border-2 border-orange-100">
          <XCircle className="w-10 h-10 text-[#F97316]" />
        </div>

        <h1 className="text-2xl font-black text-[#0F172A] font-['Outfit'] mb-2">
          Payment cancelled
        </h1>
        <p className="text-slate-500 text-sm mb-8 max-w-sm mx-auto leading-relaxed">
          No worries — you weren't charged. Your account is ready and you can complete payment anytime to start your free trial.
        </p>

        {/* Options */}
        <div className="space-y-3">
          <button
            onClick={() => navigate("/onboarding")}
            className="w-full bg-[#1E40AF] hover:bg-[#1E3A8A] text-white font-bold py-3.5 rounded-xl text-sm flex items-center justify-center gap-2 transition-all hover:scale-105">
            <Zap className="w-4 h-4" />
            Try again — start my free trial
          </button>

          <button
            onClick={() => navigate("/pricing")}
            className="w-full border border-slate-200 text-slate-600 hover:bg-slate-50 font-medium py-3.5 rounded-xl text-sm flex items-center justify-center gap-2 transition-colors">
            <ArrowLeft className="w-4 h-4" />
            Back to pricing
          </button>
        </div>

        {/* Support note */}
        <div className="mt-8 bg-white border border-slate-200 rounded-2xl p-4 text-left">
          <div className="flex items-start gap-3">
            <HelpCircle className="w-5 h-5 text-slate-400 flex-shrink-0 mt-0.5" />
            <div>
              <p className="text-sm font-semibold text-[#0F172A] mb-0.5">Have questions?</p>
              <p className="text-xs text-slate-500 leading-relaxed">
                You won't be charged until after your 3-day free trial. Email us at{" "}
                <a href="mailto:support@theordo.io" className="text-[#1E40AF] font-medium hover:underline">
                  support@theordo.io
                </a>{" "}
                if you need help.
              </p>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default PaymentCancel;
